import { PAYMENT_ENDPOINTS } from './endpoints';
/**
 * Payment API Client
 * Encapsulates all payment-related API calls.
 */
export class PaymentClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Initiates a checkout session.
     * Corresponds to: POST /api/payment/checkout
     */
    async initiateCheckout(data) {
        const response = await this.httpClient.post(PAYMENT_ENDPOINTS.INITIATE_CHECKOUT, data);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to initiate checkout session');
        }
        return response.data;
    }
    /**
     * Retrieves the current user's subscription payment details.
     * Corresponds to: GET /api/payment/subscription-details
     */
    async getSubscriptionPaymentDetails() {
        const response = await this.httpClient.get(PAYMENT_ENDPOINTS.GET_SUBSCRIPTION_DETAILS);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to retrieve subscription payment details');
        }
        return response.data;
    }
    /**
     * Cancel the current user's active subscription.
     * Corresponds to: POST /api/payment/subscription/cancel
     */
    async cancelSubscription(payload) {
        const response = await this.httpClient.post(PAYMENT_ENDPOINTS.CANCEL_SUBSCRIPTION, payload);
        if (!response.success) {
            throw new Error(response.message || 'Failed to cancel subscription');
        }
        return response;
    }
}
//# sourceMappingURL=client.js.map